import {
  GET_CASE_STATUS,
  GET_CASE_STATUS_SUCCESS,
  GET_CASE_STATUS_FAILURE,
  PUT_CASE_ACCEPT,
  PUT_CASE_ACCEPT_SUCCESS,
  PUT_CASE_ACCEPT_FAILURE,
  DELETE_CASE_REJECT,
  DELETE_CASE_REJECT_SUCCESS,
  DELETE_CASE_REJECT_FAILURE,
} from '../actions'
import {
  AnonymousStatusDto,
  ResolutionResultDto,
  UserOverrideAction,
} from '../api/types'
import { CaseState } from '../types'

export const INITIAL_CASE_STATE: CaseState = {
  caseStatusResults: null,
  caseStatusErrorMessage: '',
  caseCompletionResults: {
    isScheduled: true,
    userOverrideAction: UserOverrideAction.None,
    errors: [],
  },
  caseCompletionErrorMessage: '',
  loadingResults: false,
}

export const caseReducer = (
  state: CaseState = INITIAL_CASE_STATE,
  action: {
    type: string
    caseStatusResults?: AnonymousStatusDto | null
    caseCompletionResults?: ResolutionResultDto | null
    errorMessage?: string
  }
) => {
  const {
    type,
    caseStatusResults = null,
    caseCompletionResults = null,
    errorMessage = '',
  } = action
  switch (type) {
    case GET_CASE_STATUS:
      return { ...INITIAL_CASE_STATE, loadingResults: true }
    case GET_CASE_STATUS_SUCCESS:
      return { ...state, loadingResults: false, caseStatusResults }
    case GET_CASE_STATUS_FAILURE:
      return {
        ...state,
        loadingResults: false,
        caseStatusErrorMessage: errorMessage,
      }
    case PUT_CASE_ACCEPT:
      return { ...state, loadingResults: true }
    case PUT_CASE_ACCEPT_SUCCESS:
      return { ...state, loadingResults: false, caseCompletionResults }
    case PUT_CASE_ACCEPT_FAILURE:
      return {
        ...state,
        loadingResults: false,
        caseCompletionErrorMessage: errorMessage,
      }
    case DELETE_CASE_REJECT:
      return { ...state, loadingResults: true }
    case DELETE_CASE_REJECT_SUCCESS:
      return { ...state, loadingResults: false, caseCompletionResults }
    case DELETE_CASE_REJECT_FAILURE:
      return {
        ...state,
        loadingResults: false,
        caseCompletionErrorMessage: errorMessage,
      }
    default:
      return state
  }
}
